import * as React from 'react'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import { Helmet } from 'react-helmet'

import NewBrandDashboard from '../BrandDashboard'
import DefaultButton from '../components/DefaultButton/DefaultButton'
import IntegrationBar from '../components/IntegrationBar/IntegrationBar'

import { PageHeader } from './BrandDashboardIntegrations.style'

interface BrandDashboardIntegrationsProps {
  match?: { params: { id: string } }
}

const BrandDashboardIntegrations: React.FC<BrandDashboardIntegrationsProps> = ({ match }) => {
  const [integrationBarActive, setIntegrationBarActive] = React.useState('')

  const brandId = match && match.params.id

  React.useEffect(() => {
    document.body.className = ''
    document.body.classList.add('integrations')
    return () => {
      document.body.className = ''
      document.body.classList.add('integrations')
    }
  }, [])

  const setActiveTab = e => {
    integrationBarActive === e ? setIntegrationBarActive('') : setIntegrationBarActive(e)
  }
  const brandSettingsHeader = (
    <PageHeader>
      <DefaultButton
        fontSize="0.875rem"
        padding="0 1.8rem"
        backgroundColor="white"
        borderColor={colors.black1}
        color={colors.black1}
        buttonHeight="2.75rem"
        rounded
        hoverBackground={colors.black1}
        hoverColor="white"
        style={{ borderWidth: '2px', marginLeft: 'auto' }}
      >
        Disable publishing
      </DefaultButton>
    </PageHeader>
  )
  const integrationsData = (
    <>
      {brandSettingsHeader}
      <IntegrationBar
        checked={integrationBarActive === 'Youtube'}
        onClick={() => setActiveTab('Youtube')}
        title="Youtube"
        isDefault
      />
      <Margin bottom size="small" />
      <IntegrationBar
        checked={integrationBarActive === 'Facebook'}
        onClick={() => setActiveTab('Facebook')}
        title="Facebook"
      />
      <Margin bottom size="small" />
      <IntegrationBar
        checked={integrationBarActive === 'TikTok'}
        onClick={() => setActiveTab('TikTok')}
        title="TikTok"
      />
      <Margin bottom size="small" />
    </>
  )
  return (
    <>
      <Helmet>
        <title>Integrations - 90 Seconds</title>
      </Helmet>
      <NewBrandDashboard brandId={brandId} children={integrationsData} activeButton={6} />
    </>
  )
}

export default BrandDashboardIntegrations



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardIntegrations/BrandDashboardIntegrations.tsx